export const padNumber = (number) => (number < 10 ? `0${number}` : number);
